<template>
  <section class="faq-review" role="region" aria-labelledby="faq-title">
    <button
      @click="toggleExpanded"
      type="button"
      aria-label="Expandir o colapsar información"
      :aria-expanded="isExpanded"
      aria-controls="faq-content"
      class="faq-toggle-button"
    >
      <h2 id="faq-title" class="faq-title">{{ faqTitle }}</h2>
      <div
        class="faq-toggle"
        :class="{ expanded: isExpanded }"
      >
        <svg
          v-html="icons.chevron"
          class="faq-toggle-icon"
          aria-hidden="true"
        ></svg>
      </div>
    </button>
    <transition name="fade-slide">
      <div v-if="isExpanded" id="faq-content" class="faq-content">
        <article
          v-for="(step, index) in faqSteps"
          :key="index"
          class="faq-step"
        >
          <figure
            class="step-icon"
            v-html="getStepIcon(index)"
            aria-hidden="true"
          ></figure>
          <div class="step-content">
            <h3 class="step-title">{{ step.title }}</h3>
            <p class="step-description" v-html="step.description"></p>
          </div>
        </article>
      </div>
    </transition>
  </section>
</template>

<script>
  import messageCircle from 'assets/icons/PDP/message_circle.svg';
  import timerCircle from 'assets/icons/PDP/timer_circle.svg';
  import giftCircle from 'assets/icons/PDP/gift_circle.svg';
  import chevron from 'assets/icons/PDP/chevron.svg';
  import faqTexts from './FAQText.json';

  export default {
    name: 'faq-review',
    data() {
      return {
        isExpanded: false,
        icons: {
          messageCircle,
          timerCircle,
          giftCircle,
          chevron,
        },
      };
    },
    computed: {
      currentRegion() {
        const tld = this.$store?.tld || 'ar';
        
        if (tld === 'mx' || tld === 'pe' || tld === 'cl') {
          return 'region';
        }
        
        return 'argentina-uruguay';
      },
      faqContent() {
        return faqTexts['region-texts'][this.currentRegion] || faqTexts['region-texts']['argentina-uruguay'];
      },
      faqTitle() {
        return this.faqContent.title;
      },
      faqSteps() {
        return this.faqContent.steps;
      },
    },
    methods: {
      toggleExpanded() {
        this.isExpanded = !this.isExpanded;
      },
      getStepIcon(index) {
        const iconMap = [
          this.icons.giftCircle,
          this.icons.messageCircle,
          this.icons.timerCircle,
        ];
        return iconMap[index] || this.icons.giftCircle;
      },
    },
  };
</script>

<style scoped lang="scss">
  .faq-review {
    background-color: #ffffff;
    padding: 16px 16px 0 16px;
    border-radius: 8px;
    color: #333333;
    width: 100%;
    max-width: 627px;
    min-width: 325px;
    @media (min-width: 768px) {
      .faq-review {
        padding: 24px;
      }
    }
  }

  .faq-title {
    font-size: 20px;
    font-weight: 600;
    margin: 0;
    color: #333333;
  }
  .faq-toggle-button {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .faq-toggle {
    background: none;
    border: none;
    padding: 0;
    color: #4a9eff;
    transition: transform 0.3s ease;
    display: flex;
    align-items: center;
    cursor: pointer;

    &.expanded {
      transform: rotate(0deg);
    }

    &:not(.expanded) {
      transform: rotate(180deg);
    }

    &:hover {
      opacity: 0.8;
    }

    &:focus {
      outline: 2px solid #4a9eff;
      outline-offset: 2px;
      border-radius: 4px;
    }
  }

  .faq-toggle-icon {
    width: 24px;
    height: 24px;
  }

  .faq-content {
    margin-top: 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    border-bottom: 1px solid #e6e6e6;
    padding-bottom: 16px;
  }

  .faq-step {
    display: flex;
    gap: 16px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  .step-icon {
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    background-color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
  }

  .step-content {
    flex: 1;
  }

  .step-title {
    font-size: 16px;
    font-weight: 600;
    margin: 0 0 8px 0;
    color: #333333;
  }

  .step-description {
    font-size: 14px;
    line-height: 1.5;
    margin: 0;
    color: #666666;
  }

  .fade-slide-enter-active,
  .fade-slide-leave-active {
    transition: all 0.3s ease;
  }

  .fade-slide-enter-from,
  .fade-slide-leave-to {
    opacity: 0;
    transform: translateY(-10px);
  }
</style>
